import Phaser from 'phaser';
import { cursorCSS } from 'helpers/constants';
import { COLORS } from '../../helpers/constants';
// import WebFont from 'webfontloader';

export default class BootScene extends Phaser.Scene {
  constructor(test) {
    super({
      key: 'BootScene'
    });
    this.fontsLoaded = this.fontsLoaded.bind(this);
  }
  init() {
    // this.scene.backgroundColor = 0x000000;
    this.fontsReady = false;
  }

  preload() {
    this.load.script('webfont', './assets/scripts/webfontloader.js');

    this.add
      .text(this.cameras.main.centerX, 400, 'Loading fonts...', {
        font: '20px',
        fill: COLORS.LIGHT_BLUE,
        align: 'center'
      })
      .setOrigin(0.5);

    this.load.image('loaderBg', './assets/images/loader-bg.png');
    this.load.image('loaderBar', './assets/images/loader-bar.png');
    this.load.image('title_logo', './assets/images/title/Menu/Menu-Logo.png');
  }

  create() {
    window.WebFont.load({
      custom: {
        families: [
          'Alagard',
          'Astalemtim',
          'BitPap',
          'obi-40',
          'pixeled',
          'pixelMix',
          'pixelOperator',
          'pixelOperatorBold',
          'PressStart2P',
          'oh-forby-othry'
        ]
      },
      active: this.fontsLoaded
    });
    this.input.setDefaultCursor(cursorCSS[this.game.defaultZoom]);
  }

  update() {
    if (this.fontsReady) {
      this.scene.start('LoadingScene');
    }
  }

  fontsLoaded() {
    this.fontsReady = true;
  }
}
